/** Small "waiting for X" pill used by lobbies and results screens. */
export function WaitingPill({ children }: { children: string }) {
  return (
    <div className="inline-flex items-center gap-2 rounded-full bg-slate-100 px-4 py-2 text-sm font-medium text-slate-600 dark:bg-slate-800 dark:text-slate-300">
      <span className="size-2 animate-pulse rounded-full bg-sky-500" aria-hidden />
      {children}
    </div>
  )
}

export function hostNameOf(entries: readonly { id: string; nickname: string }[], hostId: string) {
  return entries.find((e) => e.id === hostId)?.nickname ?? 'the host'
}
